import { carouselData } from '@/mocks/home';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-10">
          精选专题
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {carouselData.map((item) => (
            <div
              key={item.id}
              className="bg-background-100 rounded-lg overflow-hidden group cursor-pointer flex flex-col"
            >
              <div className="relative w-full" style={{ paddingBottom: '62.5%' }}>
                <img
                  src={item.image}
                  alt={item.title}
                  className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  width="800"
                  height="500"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-primary-500/90 text-background-50 text-xs font-medium whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-4 flex flex-col flex-1">
                <span className="text-xs text-accent-500 font-medium mb-1">{item.subtitle}</span>
                <h3 className="text-base font-heading text-foreground-950 mb-2">{item.title}</h3>
                <p className="text-xs text-foreground-600 leading-relaxed flex-1">{item.desc}</p>
                <span className="inline-block mt-3 text-xs text-primary-500 font-medium cursor-pointer hover:text-primary-600 transition-colors whitespace-nowrap">
                  阅读更多 <i className="ri-arrow-right-line ml-1"></i>
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}